export const GREEDY_FEE = {
  nickname: 'PRODUCTS.GREEDY_FEE.shortname',
  isHidden: true,
  icon:'greedy-fee'
};
